import React from "react"

import { AppAntSwitch } from "@components"
import { priceKpi } from "@signals"


export default function AppCommonFiltersPriceKpiToggleButton({ ...props }) {
	return <AppAntSwitch
		trueText="Daily Price"
		falseText="Totally Price"
		checked={priceKpi.value}
		onChange={newValue => priceKpi.value = newValue.target.checked}
		{...props}
	/>
}